<template>
  <v-dialog v-model="dialog" max-width="20rem">
    <template v-slot:activator="{ on }">
      <v-btn small icon v-on="on">
        <v-icon small>fa-clipboard-check</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title></v-card-title>
      <v-card-text>
        <v-autocomplete
          :items="
            getRecipes.filter(
              x => x.est_intermediaire === false && x.is_deleted === false
            )
          "
          item-value="id"
          item-text="nom"
          class="no-before"
          filled
          hide-details
          v-model="product"
          label="Produit à assigner a cette clé"
          :readonly="loading"
          :loading="loading"
        ></v-autocomplete>
      </v-card-text>
      <v-card-actions>
        <v-row align="center" justify="space-between" no-gutters>
          <v-btn small text @click="dialog = false">
            Annuler
          </v-btn>
          <v-btn
            small
            color="primary"
            @click="assignToProduct"
            :disabled="product === null || loading"
          >
            Appliquer
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
export default {
  name: "InventoryTransactionProductAssigner",
  props: {
    item: {
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      "getProducts",
      "getRecipes",
      "getUncompletedIntegratedTransactions"
    ])
  },
  data() {
    return {
      dialog: false,
      product: null
    };
  },
  methods: {
    async assignToProduct() {
      try {
        this.$emit("update:loading", true);
        const data = {
          ...this.item
        };
        const recipe = this.getRecipes.find(x => x.id === this.product);
        data.fk_recipe = recipe.id;
        await api.updateIntegratedTransaction(this.item.id, data);
        this.$emit("update");
        this.dialog = false;
      } finally {
        this.$emit("update:loading", false);
      }
    }
  }
};
</script>

<style></style>
